import axios from 'axios';
import { useEffect, useState } from 'react';
import Header from '../components/Header'
import Navbar from '../components/Navbar'
import Modal from 'react-modal'
import { PATIENT } from '../services/routes';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';

const customStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)'
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        minWidth: '500px',
        bottom: 'auto',
        marginRight: '-50%',
        backgroundColor: 'white',
        transform: 'translate(-50%, -50%)',
    },
};

const Patients = () => {

    const [modalIsOpen, setIsOpen] = useState(false);

    const [patients, setPatients] = useState([])
    const [details, setDetails] = useState();
    const [textSearch, setTextSearch] = useState('')

    const [showPostModal, setShowPostModal] = useState(false)
    const [showModalDelete, setShowModalDelete] = useState(false)

    const token = localStorage.getItem('token')

    const loadPatients = async () => {
        await axios.get(PATIENT.GETALL, {
            headers: { Authorization: `Bearer ${token}` }
        })
        .then((json) => {
            setPatients(json.data.patient)
        }).catch(err => {
            console.log(err)
        })
    }
    
    
    const togglePostModal = (item) => {
        setIsOpen(!modalIsOpen);
        let date = new Date(item.birthDate)
        let day = date.getDate() + 1 < 10 ? `0${date.getDate() + 1}` : date.getDate() + 1
        let month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
        let year = date.getFullYear()
        item.aniversario = `${day}/${month}/${year}`
        setDetails(item)
        setShowPostModal(!showPostModal)
    }

    const toggleModalDelete = (item) => {
        setIsOpen(!modalIsOpen)
        setDetails(item)
        setShowModalDelete(!showModalDelete)
    }
    
    const deletePatient = async (id) => {
        try {
            await axios.delete(`${PATIENT.REMOVE.replace(/:id/gi, id)}`,
                {
                    headers: { Authorization: `Bearer ${token}` }
                })
            toast.success('Paciente deletado!')
            loadPatients()
        }
        catch (err) {
            console.log(err)
        }
    }
    
    useEffect(() => {
        loadPatients()
    }, [])

    return (
        <>
        <Helmet>
            <title>Pacientes - Coluço System</title>
        </Helmet>
            <div id="wrapper">
                {showPostModal && <Modal
                    isOpen={modalIsOpen}
                    onRequestClose={togglePostModal}
                    style={customStyles}
                    contentLabel="Modal de Paciente"
                >
                    <button className="btn btn-danger float-right" onClick={togglePostModal}>Fechar</button>
                    <h2 className="mb-4">Informações do Paciente</h2>

                    <b>Nome:</b> {details.name} {details?.lastname} <br />
                    <b>Data de Nascimento:</b> {details.aniversario} <br />
                    <b>CPF:</b> {details.cpf} <br />
                    <b>Empresa:</b> {details.company} <br />
                    <b>Profissão:</b> {details.occupation} <br />
                    <b>Email:</b> {details.email} <br />
                    <b>WhatsApp:</b> {details.phone} <br />
                    <b>CEP:</b> {details.zipCode} <br />
                    <b>Rua:</b> {details.street} <br />
                    <b>Número:</b> {details.number} <br />
                    <b>Complemento:</b> {details.adressDetails} <br />
                    <b>Bairro:</b> {details.district} <br />
                    <b>Cidade:</b> {details.city} <br />
                    <b>Estado:</b> {details.state} <br />
                    <b>Observação:</b> {details.observation} <br />
                </Modal>}

                {showModalDelete && <Modal
                    ariaHideApp={false}
                    isOpen={modalIsOpen}
                    onRequestClose={toggleModalDelete}
                    style={customStyles}
                    contentLabel="Modal de Deletar Paciente"
                >
                    <button className="btn btn-danger float-right" onClick={toggleModalDelete}>X</button>
                    <h2 className="mb-4">Deletar Paciente</h2>

                    <h5 className="align-center">Tem certeza que quer excluir este paciente?</h5>

                    <div className="d-flex mt-5 mb-4 justify-content-center">
                        {console.log(details)}
                        <button className="me-3 btn btn-danger" onClick={async () => {
                            await deletePatient(details._id)
                            toggleModalDelete()
                        }}>Excluir</button>
                        <button className="btn btn-primary" onClick={toggleModalDelete}>Fechar</button>
                    </div>

                </Modal>}

                <Header active="patients" />

                <div id="content-wrapper" className="d-flex flex-column">

                    <div id="content">

                        <Navbar />

                        <div className="container-fluid">

                            <h1 className="h3 mb-2 text-gray-800">Pacientes</h1>

                            <div className="card shadow mb-4">
                                <div className="card-header py-3">
                                    <h6 className="m-0 font-weight-bold text-primary">Lista de pacientes cadastrados</h6>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive">
                                    <div className="row">
                                            <div className="col-sm-12 col-md-6" />
                                            <div className="col-sm-12 col-md-6">
                                                <div className="text-right mb-2">
                                                    <input type="search" onChange={e => setTextSearch(e.target.value)} className="form-control" placeholder="Digite o nome do paciente ou CPF" />
                                                </div>
                                            </div>
                                        </div>
                                        <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                            <thead>
                                                <tr>
                                                    <th>Nome</th>
                                                    <th>CPF</th>
                                                    <th>#</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {patients.filter(item => {
                                                    if (textSearch === '') {
                                                        return item
                                                    }
                                                    else if (item.name.toLowerCase().includes(textSearch.toLowerCase()) || item.cpf.toLowerCase().includes(textSearch.toLowerCase())) {
                                                        return item
                                                    }
                                                }).map((item, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>{item.name} {item.lastname !== '' ? item.lastname : ''}</td>
                                                            <td>{item.cpf}</td>
                                                            <td>
                                                                {/* <button title="Novo exame" className="btn btn-success me-2"><i className="fas fa-file-medical-alt fa-fw "></i></button> */}
                                                                {/* <button title="Novo atendimento" className="btn btn-primary me-2"><i className="fas fa-calendar-plus fa-fw"></i></button> */}
                                                                <button title="Detalhes" className="btn btn-secondary me-1" onClick={() => togglePostModal(item)}><i className="fas fa-info fa-fw"></i></button>
                                                                <Link title="Editar" className="btn btn-success me-1" to={`/patients/edit/${item._id}`}><i className="fas fa-pen fa-fw "></i></Link>
                                                                <button title="Excluir" className="btn btn-danger" onClick={() => toggleModalDelete(item)}><i className="fas fa-trash fa-fw"></i></button>
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                    {patients.length <= 0 ?
                                        <div className="d-flex justify-content-center">
                                            <h6 className="">Não há pacientes cadastrados</h6>
                                        </div>
                                        :
                                        ''
                                    }
                                </div>
                            </div>

                        </div>

                    </div>

                    <Footer />

                </div>

            </div>
            <a className="scroll-to-top rounded" href="#page-top">
                <i className="fas fa-angle-up"></i>
            </a>
        </>
    )
}

export default Patients
